import { reduce } from 'ramda'

import { ReportFilterOperation } from '@driftt/api-types'

import FilterGroupBuilder from 'api/report/query/FilterGroupBuilder'
import { LeadsQualified } from 'api/report/realTime/types'

export const makeUnique = (arr: any[]) => [...new Set(arr)]

export const toPercent = (decimal, digits = 2) =>
  decimal === 0 ? 0 : parseFloat((decimal * 100).toFixed(digits))

export const toPercentString = (decimal, digits = 2) =>
  `${toPercent(decimal, digits)}%`

export const sumValues = (values: number[]) =>
  values.reduce((acc, count) => {
    acc += count
    return acc
  }, 0)

export const conditionalSumValues = (entries, condition) =>
  entries.reduce((acc, entry) => {
    const [id, count] = entry
    if (!condition || condition(id)) {
      acc += count
    }
    return acc
  }, 0)

export const filterAgentObject = (obj, filteredValues) =>
  Object.entries(obj ?? {}).reduce((acc, entry) => {
    const [id, count] = entry
    if (filteredValues.includes(id) || filteredValues.length === 0) {
      acc[id] = count
    }
    return acc
  }, {})

export const filterLeadsQualifiedByIsParticipant = (obj: LeadsQualified) => {
  return reduce(
    (acc, entry) => {
      const [agentId, countMetrics] = entry
      acc[agentId] = countMetrics.isParticipantCount
      return acc
    },
    {},
    Object.entries(obj)
  )
}

const secondsToMilliseconds = (seconds) => seconds * 1000

export const withMissedChatFilters = (query) =>
  query
    .withFilter('firstRoutingAction.type', ReportFilterOperation.NEQ, 'DIRECT')
    .withFilterGroups(
      new FilterGroupBuilder()
        .withShouldMatch(1)
        .withFilter(
          'firstRoutingAction.routingSource',
          ReportFilterOperation.EQ,
          'ROUTING_SKILL'
        )
        .withFilter(
          'firstRoutingAction.type',
          ReportFilterOperation.NEQ,
          'PLAYBOOK_ACTION'
        )
        .build()
    )
    .withFilterGroups(
      new FilterGroupBuilder()
        .withShouldMatch(1)
        //unresponsive fallbacks
        .withFilter('routingFallbackSummary.type', ReportFilterOperation.IN, [
          'UNRESPONSIVE_FALLBACK',
        ])
        //end user waited over a minute for a reply
        .withFilterGroup(
          new FilterGroupBuilder()
            .withShouldMatch(2)
            .withFilter(
              'timeToAgentResponseAfterBotMillis',
              ReportFilterOperation.GT,
              secondsToMilliseconds(60)
            )
            .withFilter(
              'firstRoutingAction.routedAgentRespondedDelay',
              ReportFilterOperation.GT,
              secondsToMilliseconds(60)
            )
            .build()
        )
        //end user got no reply... ever
        .withFilterGroup(
          new FilterGroupBuilder()
            .withShouldMatch(2)
            .withFilter(
              'firstAgentMessageAt',
              ReportFilterOperation.NOT_HAS_PROPERTY
            )
            .withFilter(
              'firstRoutingAction.routedAt',
              ReportFilterOperation.LT,
              Date.now() - secondsToMilliseconds(60)
            )
            .build()
        )
        .build()
    )

export const withCSATFilters = (query, botValues) =>
  query
    .withFilter(
      'latestLiveChatRating.ratingValue',
      ReportFilterOperation.HAS_PROPERTY
    )
    .withFilter('firstAgentId', ReportFilterOperation.HAS_PROPERTY)
    .withFilter(
      'latestLiveChatRating.ratedLiveAgentId',
      ReportFilterOperation.HAS_PROPERTY
    )
    .withFilter(
      'latestLiveChatRating.ratingValue',
      ReportFilterOperation.BETWEEN,
      ['1', '3']
    )
    // filter out bots manually since ES does not filter out agents where bot = true
    .withFilter(
      'latestLiveChatRating.ratedLiveAgentId',
      ReportFilterOperation.NOT_IN,
      botValues
    )
